// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.failresdiv {
  margin-left: 25px;
  padding-right: 33px;
}

.failresheader {
  background-color: #007887;
}

.failrestitle {
  font-size: 14px;
  color: white;
  border-radius: 2px;
  text-align: center;
}

.failresbodylist {
  /* was: 55vh originally, then 40vh; with taller audit-only modal (~70%), 48vh fits list + Close */
  min-height: 48vh;
  max-height: 48vh;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  border-bottom: 2px solid #007887;
  border-left: 2px solid #007887;
  border-right: 2px solid #007887;
  border-radius: 2px;
}

::-webkit-scrollbar {
  width: 3px !important;
}

.failresbody {
  /* Keep in sync with .failresbodylist so Close stays visible */
  min-height: 48vh;
  max-height: 48vh;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  border-bottom: 2px solid #007887;
  border-right: 2px solid #007887;
  border-radius: 2px;
}

.highchart {
  border: 2px solid #007887;
  font-size: 11px;
  min-height: 280px;
  max-height: 280px;
  margin-left: 4%;
}

.editorht {
  max-height: 63vh;
  min-height: 63vh;
}

.active_cardcolor {
  background-color: #C3EFF4;
  font-size: 12px;
}

.text2lineellips {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 40px;
  line-height: 22px;
}

.audit-toolbar {
  border-bottom: 1px solid #d9e8ea;
}

.audit-category-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.audit-category-btn {
  border: 1px solid #007887;
  background: #fff;
  color: #007887;
  border-radius: 14px;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  line-height: 1.4;
  cursor: pointer;
}

.audit-category-btn-active {
  background: #007887;
  color: #fff;
}

.audit-category-count {
  font-weight: 500;
}

.audit-search-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.audit-search-input {
  flex: 1;
  max-width: 420px;
  border-color: #007887;
}

.audit-clear-btn {
  min-width: 56px;
}

::ng-deep.diffeditor {
  height: 307px !important;
}
::ng-deep.diffeditor .monaco-diff-editor .overflow-guard {
  width: 438px !important;
}
::ng-deep.diffeditor .monaco-diff-editor .overflow-guard .monaco-scrollable-element {
  width: 390px !important;
}

::ng-deep.diffeditorlinebyline .monaco-diff-editor .overflow-guard {
  width: 774px !important;
}
::ng-deep.diffeditorlinebyline .monaco-diff-editor .overflow-guard .monaco-scrollable-element {
  width: 726px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/newaudit/newaudit.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EAAkB,mBAAA;AAEtB;;AAAE;EACE,yBAAA;AAGJ;;AAAI;EACI,eAAA;EAAgB,YAAA;EAAa,kBAAA;EAAmB,kBAAA;AAMxD;;AAHM;EACE,iGAAA;EACA,gBAAA;EACA,gBAAA;EACD,6BAAA;EAA8B,2BAAA;EAC7B,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;AAOR;;AALM;EACE,qBAAA;AAQR;;AANM;EACE,8DAAA;EACA,gBAAA;EACA,gBAAA;EACD,6BAAA;EAA8B,2BAAA;EAC7B,gCAAA;EACA,+BAAA;EACA,kBAAA;AAUR;;AARM;EACE,yBAAA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AAWV;;AATM;EACE,gBAAA;EACA,gBAAA;AAYR;;AATM;EACE,yBAAA;EACA,eAAA;AAYR;;AAVM;EACM,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;AAaZ;;AAVM;EACE,gCAAA;AAaR;;AAVM;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;AAaR;;AAVM;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AAaR;;AAVM;EACE,mBAAA;EACA,WAAA;AAaR;;AAVM;EACE,gBAAA;AAaR;;AAVM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAaR;;AAVM;EACE,OAAA;EACA,gBAAA;EACA,qBAAA;AAaR;;AAVM;EACE,eAAA;AAaR;;AAOA;EACE,wBAAA;AAJF;AAME;EACE,uBAAA;AAJJ;AAKI;EACE,uBAAA;AAHN;;AAYI;EACE,uBAAA;AATN;AAUM;EACE,uBAAA;AARR","sourcesContent":[".failresdiv{\r\n    margin-left: 25px;padding-right: 33px;\r\n  }\r\n  .failresheader{\r\n    background-color: #007887;\r\n    }\r\n\r\n    .failrestitle{\r\n        font-size: 14px;color: white;border-radius: 2px;text-align: center;\r\n      }\r\n      \r\n      .failresbodylist{\r\n        /* was: 55vh originally, then 40vh; with taller audit-only modal (~70%), 48vh fits list + Close */\r\n        min-height: 48vh;\r\n        max-height: 48vh;\r\n       overflow-x: hidden !important;overflow-y: auto !important;\r\n        border-bottom: 2px solid #007887;\r\n        border-left: 2px solid #007887;\r\n        border-right: 2px solid #007887;\r\n        border-radius: 2px;\r\n      }\r\n      ::-webkit-scrollbar {\r\n        width: 3px !important;\r\n      }\r\n      .failresbody{\r\n        /* Keep in sync with .failresbodylist so Close stays visible */\r\n        min-height: 48vh;\r\n        max-height: 48vh;\r\n       overflow-x: hidden !important;overflow-y: auto !important;\r\n        border-bottom: 2px solid #007887;\r\n        border-right: 2px solid #007887;\r\n        border-radius: 2px;\r\n      }\r\n      .highchart{\r\n        border: 2px solid #007887;\r\n          font-size: 11px;\r\n          min-height: 280px;\r\n          max-height: 280px;\r\n          margin-left:4%;\r\n      }\r\n      .editorht{\r\n        max-height: 63vh;\r\n        min-height: 63vh;\r\n      }\r\n\r\n      .active_cardcolor{\r\n        background-color: #C3EFF4;\r\n        font-size: 12px;\r\n      }\r\n      .text2lineellips{\r\n            display: -webkit-box;\r\n            -webkit-line-clamp: 2;\r\n            -webkit-box-orient: vertical;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            height: 40px;\r\n            line-height: 22px;\r\n      }\r\n\r\n      .audit-toolbar {\r\n        border-bottom: 1px solid #d9e8ea;\r\n      }\r\n\r\n      .audit-category-row {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        gap: 6px;\r\n        margin-bottom: 8px;\r\n      }\r\n\r\n      .audit-category-btn {\r\n        border: 1px solid #007887;\r\n        background: #fff;\r\n        color: #007887;\r\n        border-radius: 14px;\r\n        font-size: 11px;\r\n        font-weight: 600;\r\n        padding: 3px 10px;\r\n        line-height: 1.4;\r\n        cursor: pointer;\r\n      }\r\n\r\n      .audit-category-btn-active {\r\n        background: #007887;\r\n        color: #fff;\r\n      }\r\n\r\n      .audit-category-count {\r\n        font-weight: 500;\r\n      }\r\n\r\n      .audit-search-row {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 8px;\r\n        margin-bottom: 4px;\r\n      }\r\n\r\n      .audit-search-input {\r\n        flex: 1;\r\n        max-width: 420px;\r\n        border-color: #007887;\r\n      }\r\n\r\n      .audit-clear-btn {\r\n        min-width: 56px;\r\n      }\r\n\r\n    // ::ng-deep.failresbody  .td-wrapper{\r\n    //     display: grid !important;\r\n    // width: 100% !important;\r\n    // grid-row-gap: 1px !important;\r\n    // grid-template-columns: repeat(2,[col] 50%) !important;\r\n    // grid-template-rows: repeat(2,[row] auto) !important;\r\n    // background-color: #fff !important;\r\n    // color: #444 !important;\r\n    //   }\r\n    //   ::ng-deep.failresbody  .td-checkbox-container{\r\n    //     font-size: 14px !important;\r\n    // line-height: 22px !important;\r\n    //   }\r\n    //   ::ng-deep.failresbody  .checkmark{\r\n    //     top: 3px !important;\r\n    //   }\r\n\r\n::ng-deep.diffeditor{\r\n  height: 307px !important;\r\n.monaco-diff-editor{\r\n  .overflow-guard{\r\n    width: 438px !important;\r\n    .monaco-scrollable-element{\r\n      width: 390px !important;\r\n    }\r\n  }\r\n  \r\n}\r\n}\r\n\r\n::ng-deep.diffeditorlinebyline{\r\n  .monaco-diff-editor{\r\n    .overflow-guard{\r\n      width: 774px !important;\r\n      .monaco-scrollable-element{\r\n        width: 726px !important;\r\n      }\r\n    }\r\n  }\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
